import { Button } from "@/components/ui/button";
import { AlertTriangle, LogOut, Eye } from "lucide-react";
import { useSupportMode } from "@/hooks/useSupportMode";
import { formatDistanceToNow } from "date-fns";

export function SupportModeBanner() {
  const { supportMode, exitSupportMode } = useSupportMode();

  if (!supportMode.active) return null;

  const duration = supportMode.enteredAt
    ? formatDistanceToNow(new Date(supportMode.enteredAt), { addSuffix: false })
    : "just now";
  const organizationName = supportMode.tenantContext?.organizationName ?? "this organization";

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-warning-500 text-warning-700 px-4 py-2">
      <div className="max-w-screen-xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <Eye className="h-5 w-5" />
            <span className="font-semibold">Support Mode Active</span>
          </div>
          <span className="hidden sm:inline text-warning-700">
            Viewing <strong>{organizationName}</strong> • {duration}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <span className="hidden md:inline text-xs text-warning-700">
            All actions are being logged
          </span>
          <Button
            size="sm"
            variant="secondary"
            className="bg-warning-100 hover:bg-warning-200 text-warning-700"
            onClick={exitSupportMode}
          >
            <LogOut className="h-4 w-4 mr-1" />
            Exit Support Mode
          </Button>
        </div>
      </div>
    </div>
  );
}
